import { useNavigate } from "react-router-dom";

import { Models } from "api/types";
import { CircleProgressTracker } from "atoms/circle-progress-tracker/CircleProgressTracker";
import { ProgressInfo } from "utils/retailProducts.helpers";

import {
  RetailProductOrderCard,
  RetailProductTrackShippingButton,
} from "../index";

export interface RetailProductDeliverySectionProps {
  deliveryItems: Models<"DisplayRetailProductOrderLineItemForShipping">[];
  deliveryProgress: ProgressInfo;
  orderType: string;
  context: "wallet" | "product-details";
}

export const RetailProductDeliverySection = ({
  deliveryItems,
  deliveryProgress,
  orderType,
  context,
}: RetailProductDeliverySectionProps) => {
  const navigate = useNavigate();

  if (deliveryItems.length === 0) return null;
  const shipmentTrackingUrl = deliveryItems[0].shipmentTrackingUrl;

  return (
    <div>
      <div className="mb-3 text-left text-bold3 uppercase">Delivery</div>
      <div className="mb-4 space-y-3">
        {deliveryItems.map((lineItem) => (
          <RetailProductOrderCard
            underline
            context={context}
            key={lineItem.packageId}
            name={lineItem.name.text}
            imageUri={lineItem.thumbnailImageUri || undefined}
            totalQuantity={lineItem.totalQuantity}
            estimatedDeliveryDateAtUtc={
              lineItem.estimatedDeliveryDateAtUtc || undefined
            }
            onClick={() =>
              navigate(`/pdp/product/${lineItem.packageListingId}`)
            }
          />
        ))}
      </div>
      {orderType !== "past" && context !== "wallet" && (
        <div className="mb-4 w-full">
          <div className="mb-2 text-center">
            <p className="text-bold3 text-chip uppercase">
              {deliveryProgress.statusText}
            </p>
          </div>
          <CircleProgressTracker
            current={deliveryProgress.current}
            max={deliveryProgress.max}
          />
        </div>
      )}
      {shipmentTrackingUrl && (
        <RetailProductTrackShippingButton
          shipmentTrackingUrl={shipmentTrackingUrl}
        />
      )}
    </div>
  );
};
